import '../form/input.css'

function PlusSinal({ onClick, title }) {
    return (
        <div onClick={onClick} title={title}>
            <div className="plus-sinal">
                <div className="plus-sinal-tip"></div>
                <div className="plus-sinal-middle"></div>
                <div className="plus-sinal-tip"></div>
            </div>
        </div>
    )
}

export default PlusSinal
